<template>
  <el-dialog
    :title="this.form.protocol"
    :visible="editorVisibleProp"
    @close="Close"
    @open="Open"
  >
    <el-form :model="form" ref="form">
      <el-form-item
        label="用户名"
        prop="username"
        :label-width="formLabelWidth"
        :rules="[{ required: true, message: '用户名不能为空' }]"
      >
        <el-input v-model="form.username" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="密码"
        prop="password"
        :label-width="formLabelWidth"
        :rules="[{ required: true, message: '密码不能为空' }]"
      >
        <el-input
          type="password"
          v-model="form.password"
          autocomplete="off"
          @keydown.enter.native="submitForm"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="Close">取 消</el-button>
      <el-button type="primary" @click="submitForm">连 接</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  props: { selectedRow: Object, editorVisibleProp: Boolean },
  data() {
    return {
      form: {
        username: 'root',
        password: '',
        port: Number,
        protocol: '',
      },
      formLabelWidth: '120px',
    };
  },
  methods: {
    Open() {
      this.form.protocol = this.selectedRow.Protocol;
    },
    submitForm(formName) {
      this.form.port = this.selectedRow.ServerPort;
      this.form.protocol = this.selectedRow.Protocol;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.Close();
          this.$emit('connectData', this.form);
          return true;
        }
        console.log('error submit!!');
        return false;
      });
    },
    Close() {
      this.$emit('update:editorVisibleProp', false);
    },
  },
};
</script>
